<template>
  <div>
    <EmptyCardModal
      v-if="modalData && modalData.open"
      :modalData="modalData"
      :onModalClose="(reset) => modalData.open = false"
      :onModalAccept="updateChangeQty"
    >
      <slot>
        <ChangeQtyBlock
          ref="changeBlock"
          :drug="modalData.drug"
        />
      </slot>
    </EmptyCardModal>
  </div>
</template>

<script>

import EmptyCardModal from "@/components/modals/EmptyCardModal";
import ChangeQtyBlock from "@/components/invoices/ChangeQtyBlock";

export default {
  props: ['modalData', 'onAccept'],
  components: {
    EmptyCardModal,
    ChangeQtyBlock,
  },
  data() {
    return {}
  },
  created() {
    this.$set(this.modalData, 'open', true);
  },
  methods: {
    updateChangeQty() {
      const data = {...this.$refs.changeBlock.newData};
      if (data.new_qty < 0) {
        toastr['warning']('количество не может быть меньше 0');
        return;
      }

      if (data.new_qty > +(this.modalData.drug.remain || 0)) {
        toastr['warning']('количество не может быть больше, чем на складе отправителя');
        return;
      }

      console.log(+data.new_qty, +this.modalData.drug.qty, data.comment)
      if (+data.new_qty !== +(this.modalData.drug.qty || 0) && !data.comment) {
        toastr['warning']('Требуется ввести комментарий');
        return;
      }

      if (this.onAccept) {
        this.onAccept({...data, drugId: this.modalData.drug.id});
      }
      // const index = this.drugs.findIndex((d) => d.id === this.modalChangeQtyData.drug.id);
      // this.drugs[index].new_qty = data.new_qty;
      // this.drugs[index].invoice_comment = data.invoice_comment;
      //
      // this.filteredDrugs[filteredIndex].new_qty = data.new_qty;
      // this.filteredDrugs[filteredIndex].invoice_comment = data.invoice_comment;

      // this.modalChangeQtyData = null;
    },
  }
}

</script>
